import { Box, Grid, Typography } from '@mui/material'

import NativeAppBannerPng from '~/assets/images/home/png/nativeApp@1x.png'
import NativeAppBannerPng2x from '~/assets/images/home/png/nativeApp@2x.png'
import NativeAppBannerWebp from '~/assets/images/home/webp/nativeApp@1x.webp'
import NativeAppBannerWebp2x from '~/assets/images/home/webp/nativeApp@2x.webp'
import { BrandColor } from '~/config/theme'
import AppStoreBlock from '~/components/AppStore/AppStoreBlock'

export const NativeAppPromotionBanner: React.FC = () => {
  return (
    <Box sx={{ display: 'flex', background: BrandColor.LIGHT_GREY, borderRadius: 4, width: '100%', paddingLeft: 2.5 }}>
      <Grid container>
        <Grid item xxs={4} sx={{ display: 'flex', flexDirection: 'column' }}>
          <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            flexGrow: 1,
            padding: 1,
            paddingLeft: 0,
            height: 0,
            overflow: 'hidden',
            minWidth: 110,
          }}>
            <Box
              component='picture'
              sx={{
                width: '100%',
                height: '100%',
                display: 'flex',
                maxHeight: { xxs: '110px', xs: '150px', sm: '150px', md: '300px' },
                objectFit: 'cover',
              }}
            >
              <source srcSet={`${NativeAppBannerWebp2x} 2x, ${NativeAppBannerWebp} 1x`} type='image/webp' />
              <source srcSet={`${NativeAppBannerPng2x} 2x, ${NativeAppBannerPng} 1x`} type='image/png' />
              <Box component="img" src={NativeAppBannerPng} alt='NativeApp Banner' sx={{ maxWidth: '100%', maxHeight: '100%', borderRadius: 2, objectFit: 'cover' }} />
            </Box>
          </Box>
        </Grid>
        <Grid item xxs={8} sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
          <Box sx={{ display: 'flex', flexGrow: 1, flexDirection: 'column', justifyContent: { xxs: 'center', xs: 'space-evenly' }, padding: { xxs: 'unset', xs: 2.5 }, maxHeight: '250px' }}>
            <Typography sx={{
              color: BrandColor.BLACK,
              fontWeight: 600,
              textAlign: 'left',
              fontSize: { sm: 24, md: 30 },
              mb: 1,
              pl: 1,
            }}>
              New Application!
            </Typography>
            <Typography sx={{
              color: BrandColor.BLACK,
              fontWeight: '600',
              fontSize: {
                xxs: 12,
                sm: 14,
                md: 18,
              },
              position: 'relative',
              ml: { xxs: 1 },
              mb: 1,
            }}>
              Please register via our app
            </Typography>
            <AppStoreBlock />
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}
